import type { LucideIcon } from "lucide-react";
import {
  BarChart3,
  Boxes,
  GitCommitHorizontal,
  Home,
  Link2,
  Package,
  Receipt,
  ScrollText,
  Settings,
  ShieldCheck,
  Store,
  TrendingUp,
  Users,
  UserCheck,
} from "lucide-react";
import type { Role } from "@/types/auth";

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** end=true → exact match only (used for portal home routes). */
  end?: boolean;
  /** Show in the mobile bottom bar (max 5 fit comfortably). */
  primary?: boolean;
}

export const NAV: Record<Role, NavItem[]> = {
  wholesaler: [
    { label: "Stock", to: "/wholesaler", icon: Home, end: true, primary: true },
    { label: "Orders", to: "/wholesaler/orders", icon: Receipt, primary: true },
    { label: "Connections", to: "/wholesaler/connections", icon: UserCheck, primary: true },
    { label: "Analytics", to: "/wholesaler/analytics", icon: BarChart3, primary: true },
    { label: "Profile", to: "/wholesaler/profile", icon: Settings },
  ],
  reseller: [
    { label: "Stock feed", to: "/reseller", icon: Boxes, end: true, primary: true },
    { label: "Wholesalers", to: "/reseller/wholesalers", icon: Store, primary: true },
    { label: "Orders", to: "/reseller/orders", icon: Receipt, primary: true },
    { label: "Integration", to: "/reseller/integration", icon: Link2, primary: true },
    { label: "Profile", to: "/reseller/profile", icon: Settings },
  ],
  admin: [
    { label: "Overview", to: "/admin", icon: Home, end: true, primary: true },
    { label: "Members", to: "/admin/members", icon: Users, primary: true },
    { label: "Orders", to: "/admin/orders", icon: Receipt, primary: true },
    { label: "Market data", to: "/admin/market", icon: TrendingUp },
    { label: "Audit log", to: "/admin/changelog", icon: ScrollText, primary: true },
    { label: "Changelog", to: "/admin/release-notes", icon: GitCommitHorizontal },
    { label: "Settings", to: "/admin/settings", icon: Settings },
  ],
};

export const ROLE_ICON: Record<Role, LucideIcon> = {
  wholesaler: Package,
  reseller: Store,
  admin: ShieldCheck,
};
